import { prayerAndTalksConstants } from "../actions/constants/prayerAndTalksConstant";

const prayerData = (state = { status: "", message: "" }, action: any) => {
	switch (action.type) {

		case prayerAndTalksConstants.prayerAndTalksDetailRequest:
			return {
				...state,
				isLoading: true,
				isSuccess: false,
				isError: false,
			};
		case prayerAndTalksConstants.prayerAndTalksDetailSuccess:
			return {
				...state,
				isLoading: false,
				isSuccess: true,
				isError: false,
				isDetailComplete: true,
				prayerInput: action.payload,
			};
		case prayerAndTalksConstants.prayerAndTalksDetailFailure:
			return {
				...state,
				isLoading: false,
				isSuccess: false,
				isError: true,
				isDetailComplete: true,
				status: action.payload,
			};

		case prayerAndTalksConstants.prayerAndTalksGetChannelRequest:
			return {
				...state,
				isLoading: true,
				isSuccess: false,
				isError: false,
			};
		case prayerAndTalksConstants.prayerAndTalksGetChannelSuccess:
			return {
				...state,
				isLoading: false,
				isError: false,
				channelData: action.payload,
			};
		case prayerAndTalksConstants.prayerAndTalksGetChannelFailure:
			return {
				...state,
				isLoading: false,
				isSuccess: false,
				isError: true,
				status: action.payload,
			};

		case prayerAndTalksConstants.prayerAndTalksSaveRequest:
			return {
				...state,
				isLoading: true,
				isFormSubmit: true,
				isError: false,
				isSuccess: false,
				isUpdateStatus: false,
				prayerInput: action.input,
			};
		case prayerAndTalksConstants.prayerAndTalksSaveSuccess:
			return {
				...state,
				isLoading: false,
				isFormSubmit: false,
				isError: false,
				isSuccess: true,
				isUpdateStatus: true,
				status: action.payload.status,
			};
		case prayerAndTalksConstants.prayerAndTalksSaveFailure:
			return {
				...state,
				isLoading: false,
				isFormSubmit: false,
				isSuccess: false,
				isError: true,
				isUpdateStatus: true,
				status: action.payload,
			};

		default:
			return state;
	}
};

export default prayerData;
